export enum OrderStatus {
  CONFIRMED = 'Confirmado',
}
